import { shallowEqual, useSelector } from 'react-redux'
import classes from './PatientTabs.module.css'
import { useState } from 'react'
import { AttyTabColor, CrimeVictimColor, LienColor, SelfPayColor, TransportationColor, WorkerCompColor } from '../../../lib/detailsTabsColors'
import ChatUnread from './ChatUnread'
import BodySimpleModalV3 from '../../common/modal/BodySimpleModalV3'
import { liabilityFunctions } from '../../../lib/liability'
import { umFunctions } from '../../../lib/um'
import { majormedFunctions } from '../../../lib/majormed'
import { medpayFunctions } from '../../../lib/medpay'
import { SOSColor } from '../../../lib/detailsTabsColors'

const DEFAULT_TAB_STATUS = {
    dot: false,
    dot_color: null,
    background: null,
    color: null,
    message: null,
    classColor: null,
}

function getTabStatus(activeCase, type) {
    if (!activeCase) {
        return DEFAULT_TAB_STATUS
    }

    if (type == 'atty') {
        return AttyTabColor(activeCase.attorneys, activeCase.liabilities, activeCase.additional, activeCase)
    }
    if (type == 'liability') {
        return liabilityFunctions.liabilityVerification(activeCase.liabilities)
    }
    if (type == 'medpay') {
        return medpayFunctions.medpayVerification(activeCase.mp_pip_um, activeCase)
    }
    if (type == 'um') {
        return umFunctions.umVerification(activeCase.mp_pip_um, activeCase.liabilities)
    }
    if (type == 'crimevictim') {
        return CrimeVictimColor(activeCase.crime_victim, activeCase.liabilities)
    }
    if (type == 'majormed') {
        return majormedFunctions.majormedVerification(activeCase.major_meds, activeCase)
    }
    if (type == 'lien') {
        return LienColor(activeCase.patient)
    }
    if (type == 'workercomp') {
        return WorkerCompColor(activeCase.worker_comp, activeCase.case)
    }
    if (type == 'selfpay') {
        return SelfPayColor(activeCase.selfpay, activeCase, activeCase.practices)
    }
    if (type == 'transportation') {
        return TransportationColor(activeCase.case_transportation, activeCase.patient, activeCase.practices)
    }
    if (type == 'case_sos') {
        return SOSColor(activeCase.case_sos)
    }

    return DEFAULT_TAB_STATUS
}

export default function PatientTabButton({ item, clickAction, drawerClickOverride, activeTabOverride, disabled }) {
    const tabStatus = useSelector((state) => getTabStatus(state.case.activeCase, item.type), shallowEqual)
    const activeTab = useSelector((state) => {
        if (typeof activeTabOverride === 'boolean') {
            return null
        }
        return state.details.detailsTabs
    })
  

    function clickHandler() {
        if (typeof drawerClickOverride === 'function') {
            drawerClickOverride()
            return
        }
        clickAction(item.id)
    }

    const [showHelper, setShowhelper] = useState(false)
    const mouseEnterHandler = () => {
        setShowhelper(true)
    }
    const mouseLeaveHandler = () => {
        setShowhelper(false)
    }

    let messageHTML = tabStatus.message ? <div className={classes.message_inner} dangerouslySetInnerHTML={{__html: tabStatus.message}}></div> : null

    const isActive =
        typeof activeTabOverride === 'boolean' ? activeTabOverride : activeTab == item.id

    return <BodySimpleModalV3 message={messageHTML} disabled={!showHelper && !messageHTML}>
        <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            disabled={!!disabled}
            onClick={clickHandler}
            className={`${classes.tab} ${isActive ? classes.active : ''} ${tabStatus.classColor ? tabStatus.classColor : ''}`}
            style={{ background: tabStatus.background, color: tabStatus.color }}
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
        >
            
            {item.name}
            {tabStatus.dot && <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="currentColor" ><path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                <path fill={tabStatus.dot_color ? tabStatus.dot_color : ''} d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z" />
            </svg>}

            {item.type == 'procodocs' && <ChatUnread />}
        </button>
    </BodySimpleModalV3>


}